import { HttpService } from "@/core";
import { ExportReq, ExportResp } from "@/core/interface";
import {
  ProfilePageReq,
  ProfilePageResp,
  ProfileDetailResp,
  ProfileReq,
  ContractSimpleListReq,
  ContractSimpleListResp,
} from "./profile.interface";
import { ProfileService as ProjectService } from "@/views/project/profile/profile.service";
import { TeamTypeEnum } from "@/views/project";
import { QuantityRecordReq } from "../visa/form/quantity-table/quantity-table.interface";
import { MaterialRecordReq } from "../visa/form/material-table/material-table.interface";

export class ProfileService {
  static usePageApi() {
    const api = (params: ProfilePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/contract/pageList",
        params,
      });
    return HttpService.usePagination<ProfilePageResp>(api);
  }

  static useSimpleListApi() {
    const api = (params: ContractSimpleListReq) =>
      HttpService.axios({
        method: "GET",
        url: "/completion/completionSettlement/contract/simple/list",
        params,
      });
    return HttpService.usePagination<ContractSimpleListResp>(api);
  }

  static useSupplierContractsApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_contract/simple/list/supplier",
        params,
      });
    return HttpService.useRequest<ContractSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/${id}`,
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }

  static useQuantitiesApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/${id}/quantities`,
      });
    return HttpService.useRequest<QuantityRecordReq>(api);
  }

  static useMaterialApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/${id}/material`,
      });
    return HttpService.useRequest<MaterialRecordReq>(api);
  }

  static useCreateApi() {
    const api = (data: ProfileReq) =>
      HttpService.axios({
        method: "POST",
        url: "/contract/all",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: ProfileReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/contract/${id}`,
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/contract/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "GET",
        url: "/contract/export",
        params: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static detailRespToProfileReq(resp: ProfileDetailResp) {
    const profileReq = new ProfileReq();
    profileReq.pick(resp);
    return profileReq;
  }

  static async fetchProjectFields(projectId) {
    const result = {
      salesmanUserId: "",
      projectManagerUserId: "",
      customer: {},
    };
    const { run } = ProjectService.useDetailApi();
    const res = await run(projectId);
    if (res.respCode === "0000" && res.data) {
      const { teams, customer } = res.data;
      const smUser = teams.find((item) => Number(item.type) === TeamTypeEnum.BIZ_MAN);
      if (smUser) {
        result.salesmanUserId = smUser.tenantUserId;
      }
      const pmUser = teams.find((item) => Number(item.type) === TeamTypeEnum.PROJECT_MANAGER);
      if (pmUser) {
        result.projectManagerUserId = pmUser.tenantUserId;
      }
      result.customer = customer;
    }
    return result;
  }
  static useProjectInfoApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/project/${id}`
      });
    return HttpService.useRequest<any>(api);
  }
}
